"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var styles = require("../../Table.css");
var icons = require("../../../../../styles/att-icons.css");
require("./Th.css");
var TableProps_1 = require("../../TableProps");
var Th = /** @class */ (function (_super) {
    __extends(Th, _super);
    function Th(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            sortOrder: _this.props.options.sortOrder,
        };
        _this.handleClick = _this.handleClick.bind(_this);
        _this.renderSortArrow = _this.renderSortArrow.bind(_this);
        _this.handleKeyPress = _this.handleKeyPress.bind(_this);
        return _this;
    }
    Th.prototype.handleClick = function () {
        if (!this.props.options.sortable) {
            return;
        }
        // this.setState({sortOrder: this.state.sortOrder === SortOrder.DESC ? SortOrder.ASC : SortOrder.DESC});
        var _a = this.props.options, dataType = _a.dataType, key = _a.key;
        if (this.props.events && this.props.events.onSort) {
            this.props.events.onSort(dataType, key, this.props.options.sortOrder);
        }
    };
    Th.prototype.handleKeyPress = function (e) {
        if (!this.props.options.sortable) {
            return;
        }
        var isValidKeyCode = e.charCode;
        if (isValidKeyCode !== 13 && isValidKeyCode !== 32) {
            return;
        }
        // this.setState({sortOrder: this.state.sortOrder === SortOrder.DESC ? SortOrder.ASC : SortOrder.DESC});
        var _a = this.props.options, dataType = _a.dataType, key = _a.key;
        if (this.props.events && this.props.events.onSort) {
            this.props.events.onSort(dataType, key, this.props.options.sortOrder);
        }
    };
    Th.prototype.renderSortArrow = function () {
        var arrowClasses = this.props.options && this.props.options.sortArrowClassName ? [styles.sortArrow, this.props.options.sortArrowClassName] :
            [styles.sortArrow, icons.attIcon, icons.attIconVerticalArrow2];
        if (this.props.options.sortOrder && this.props.options.sortOrder === TableProps_1.SortOrder.ASC) {
            arrowClasses.push(styles.reverse);
        }
        return (React.createElement("i", { className: arrowClasses.join(' ') }));
    };
    Th.prototype.render = function () {
        var _a = this.props, testId = _a.testId, children = _a.children;
        var classnames = this.props.options && this.props.options.sortable
            ? [this.props.options.className, styles.sortable]
            : [this.props.options.className];
        if (this.props.options && this.props.options.sortOrder) {
            classnames.push(styles.sorted);
        }
        return (React.createElement("th", { "data-test-id": testId, role: "columnheader", scope: "col", className: classnames.join(' '), style: { width: (this.props.options && this.props.options.colWidth ? this.props.options.colWidth : null) }, onClick: this.props.options && this.props.options.sortable ? this.handleClick : null, onKeyPress: this.handleKeyPress },
            !this.props.options.sortable &&
                children,
            this.props.options && this.props.options.sortable &&
                React.createElement("button", { tabIndex: 0, "aria-label": this.props.options.sortOrder ? (this.props.options.sortOrder === TableProps_1.SortOrder.ASC ?
                        this.props.children + ' Sort Ascending' : this.props.children + ' Sort Descending') :
                        this.props.children + ' Sortable' },
                    children,
                    this.renderSortArrow())));
    };
    Th.defaultProps = {
        options: {
            className: '',
        },
    };
    return Th;
}(React.Component));
exports.default = Th;
//# sourceMappingURL=Th.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/containers/Table/components/Th/Th.js
// module id = 1366
// module chunks = 8